export default "__VITE_ASSET__e2a2cfdc__"